import { FC } from 'react';

import { BANNER_IMAGE_CROP_DEFAULT } from 'utils/constants/banner';

import withErrorBoundary from 'components/common/ErrorBoundary/withErrorBoundary';
import { MagritteBannerPreviewSidebar } from 'components/common/MagritteBannerPreviewSidebar/MagritteBannerPreviewSidebar';

import { useSelector } from 'store/utils';

const BannerPreviewSidebarComponent: FC = () => {
    const {
        bannerTitle,
        bannerText,
        images: {
            [BANNER_IMAGE_CROP_DEFAULT]: { url: image },
        },
        bannerVacancyId,
    } = useSelector((state) => state.createBanner);

    return (
        <MagritteBannerPreviewSidebar
            title={bannerTitle}
            text={bannerText}
            image={image}
            showBannerExamples
            vacancyId={bannerVacancyId}
        />
    );
};

const BannerPreviewSidebar = withErrorBoundary(BannerPreviewSidebarComponent);
export { BannerPreviewSidebar };
